import {handleTextChunk} from "./textChunkHandler/textChunkHandler.ts";
import {setupToolCall} from "./toolCallHandlers/toolCallInit/toolCallInitHandler.ts";
import {handleFinishStream} from "./responseFinish/finishResponse.ts";
import {addTokensToChart, removeAiCursor} from "./responseFinish/Utils.ts";
import {updateToolCall} from "../../contextManagement/toolCallUpdater.ts";
import {handleThinkingChunk, handleThinkingFinish, handleThinkingRedacted} from "./thinkingHandler/thinkingHandler.ts";
import {finishToolCall} from "./toolCallHandlers/toolCallFinish/toolCallFinishHandler.ts";

const handleMessageReceived = (message: any, llmRequestRefs: any, settingsObjRef: any, userObjRef: any, environmentObjRef: any, setMessages: any, messagesRef: any, currentMessageRef: any, messagesSequenceRef: any, updateElementInProgress: any, updateSessionUsage: any, websocketRef: any, dynamicStateObjRef: any) => {
    switch (message.type) {
        case 'chunk':
        case 'done':
        case 'error':
            return message;
        case 'thinkingChunk':
            handleThinkingChunk(message, currentMessageRef, llmRequestRefs, setMessages);
            return null;
        case 'thinkingFinish':
            handleThinkingFinish(message, currentMessageRef);
            return null;
        case 'redacted_thinking':
            handleThinkingRedacted(message, currentMessageRef);
            return null;
        case 'toolCallRequestInit':
            removeAiCursor(llmRequestRefs, setMessages);
            setupToolCall(llmRequestRefs, currentMessageRef, updateElementInProgress, setMessages, message);
            return null;
        case 'toolCallRequestFinish':
            llmRequestRefs.current.toolCalls[message.id] = message;
            finishToolCall(llmRequestRefs, settingsObjRef, userObjRef, environmentObjRef, llmRequestRefs.current.toolCalls[message.id], setMessages, messagesRef, currentMessageRef, messagesSequenceRef, updateElementInProgress, websocketRef, dynamicStateObjRef);
            return null;
        case 'editFileAdd':
            const existingArgs = llmRequestRefs.current.toolCalls[message.id].args;
            const updatedArgs = {
                ...existingArgs,
                newContents: existingArgs.newContents + message.newContents
            };
            updateToolCall(llmRequestRefs, message.id, { args: updatedArgs });
            setMessages((prev: any) => prev.deepCopy());
            return null;
        case 'tokenUsage':
            addTokensToChart(message, updateSessionUsage);
            return null;
    }
}

export const handleLlmResponseChunk = async (args: any, llmRequestRefs: any, settingsObjRef: any, userObjRef: any, setMessages: any, environmentObjRef: any, messagesRef: any, currentMessageRef: any, messagesSequenceRef: any, setDynamicStateObj: any, updateElementInProgress: any, updateSessionUsage: any, websocketRef: any, dynamicStateObjRef: any) => {
    if (llmRequestRefs.current.streamId !== args.streamId) {
        if (args.type === "tokenUsage") handleMessageReceived(args, llmRequestRefs, settingsObjRef, userObjRef, environmentObjRef, setMessages, messagesRef, currentMessageRef, messagesSequenceRef, updateElementInProgress, updateSessionUsage, websocketRef, dynamicStateObjRef);
        else return;
    }
    if (args.type !== "tokenUsage" && llmRequestRefs.current.aiMessage?.message?.isLoading) {
        llmRequestRefs.current.aiMessage.message = {
            ...llmRequestRefs.current.aiMessage.message,
            isLoading: false
        };
    }
    const message = handleMessageReceived(args, llmRequestRefs, settingsObjRef, userObjRef, environmentObjRef, setMessages, messagesRef, currentMessageRef, messagesSequenceRef, updateElementInProgress, updateSessionUsage, websocketRef, dynamicStateObjRef);

    if (message) {
        if (message.type === "chunk" && "chunk" in message) {
            handleTextChunk(message, currentMessageRef, environmentObjRef, llmRequestRefs, setMessages);
        } else if (message.type === "error") {
            setDynamicStateObj({errorMessage: message.message});
            handleFinishStream(llmRequestRefs, setMessages, updateElementInProgress);
        } else if (message.type === "done") {
            handleFinishStream(llmRequestRefs, setMessages, updateElementInProgress);
        }
    }
}
